import React from 'react';
import classNames from 'classnames/bind';
import { DeliveryOutlineIcon, Link, StorePickupIcon } from '@beef/ui-kit';
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var DeliveryOptionsSection = function DeliveryOptionsSection(_ref) {
  var _device$delivery, _device$pickup;
  var device = _ref.device;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, (device === null || device === void 0 ? void 0 : device.delivery) &&
  /*#__PURE__*/
  // TODO поменять в ссылках цвет после согласования
  React.createElement("div", {
    className: cx('link-wrapper')
  }, /*#__PURE__*/React.createElement(Link, {
    href: device.delivery.link,
    icon: /*#__PURE__*/React.createElement(DeliveryOutlineIcon, {
      size: "s"
    }),
    isNoUnderline: true,
    onClick: (_device$delivery = device.delivery) === null || _device$delivery === void 0 ? void 0 : _device$delivery.onClick,
    size: "size5-r-l",
    variant: "light"
  }, device.delivery.label)), (device === null || device === void 0 ? void 0 : device.pickup) && /*#__PURE__*/React.createElement("div", {
    className: cx('link-wrapper')
  }, /*#__PURE__*/React.createElement(Link, {
    href: device.pickup.link,
    icon: /*#__PURE__*/React.createElement(StorePickupIcon, {
      size: "s"
    }),
    isNoUnderline: true,
    onClick: (_device$pickup = device.pickup) === null || _device$pickup === void 0 ? void 0 : _device$pickup.onClick,
    size: "size5-r-l",
    variant: "light"
  }, device.pickup.label)));
};